import { render, staticRenderFns } from "./ProfileSidebarProjectSummary.vue?vue&type=template&id=2fc05b4a&scoped=true"
import script from "./ProfileSidebarProjectSummary.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSidebarProjectSummary.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileSidebarProjectSummary.vue?vue&type=style&index=0&id=2fc05b4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc05b4a",
  null
  
)

export default component.exports